import { Process } from "@/types/contract";
import { Product } from "@/types/enumerations";
import { Campaigns } from "@/types/schemas/campaigns";
import { getContractDuration } from "@/utils/product";
import dayjs from "dayjs";
import { TFunction } from "i18next";
import { Trans } from "react-i18next";
import Text from "@/components/Text";
import { DateFormat } from "@/constants/common";

export const getContractStartDay = (
  campaign: Campaigns | null,
  process: Process,
  product: Product,
  t: TFunction<"banner">,
  tCommon: TFunction<"common">
) => {
  if (!campaign || process !== Process.RECONTRACTING) {
    return getContractDuration(process, product, tCommon);
  }
  const today = new Date();
  const isSameAsToday = dayjs(campaign.contractStartDate).isSame(today, "day");
  const immediately = !campaign.contractStartDate || isSameAsToday;
  const isAfterToday = dayjs(campaign.contractStartDate).isSameOrAfter(today, "day");

  if (immediately) {
    return t("startsImmediately");
  }
  if (isAfterToday) {
    if (campaign.fix) {
      return (
        <Text variant="reading_medium">
          <Trans
            t={t}
            i18nKey="startsContinuously"
            values={{
              date: dayjs(campaign.contractStartDate).format(DateFormat),
            }}
          />
        </Text>
      );
    } else {
      return (
        <Text variant="reading_medium">
          <Trans
            t={t}
            i18nKey="startsAfter"
            values={{
              date: dayjs(campaign.contractStartDate).format(DateFormat),
            }}
          />
        </Text>
      );
    }
  }
};
